var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41395 1.85026L1.41396 1.85026L1.41427 1.84762C1.42739 1.73644 1.46629 1.62986 1.52788 1.53637C1.58946 1.44288 1.67203 1.36506 1.769 1.30911C1.86597 1.25317 1.97466 1.22064 2.08642 1.21411C2.19818 1.20759 2.30992 1.22725 2.41274 1.27154L2.41274 1.27154L2.41463 1.27235C3.45502 1.71711 5.80733 2.78307 8.79647 4.50826C11.786 6.23408 13.8858 7.73946 14.7906 8.41684C15.1791 8.7084 15.1799 9.28077 14.7908 9.57318L14.7908 9.5732C13.8969 10.2451 11.8231 11.7308 8.79627 13.4793C5.76674 15.2277 3.44255 16.2805 2.41358 16.7187L2.41283 16.719C1.96749 16.9092 1.47221 16.6235 1.41403 16.1418L1.41402 16.1417C1.27883 15.023 1.02344 12.4607 1.02344 8.99472C1.02344 5.53056 1.27787 2.96931 1.41395 1.85026Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.adc8f0529ec7315755d97ed5b33b0065.svg";
export { ForwardRef as ReactComponent };